import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-thankyou-popup',
  templateUrl: './thankyou-popup.component.html',
  styleUrls: ['./thankyou-popup.component.scss']
})
export class ThankyouPopupComponent implements OnInit {
  popupdata;

  constructor(private dialog: MatDialogRef<ThankyouPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { 
    this.popupdata = data[0];
    
  }

  ngOnInit(): void {
  }

}



// {
//   "success": true,
//   "message": [
//       {
//           "refno": "O-12343114",
//           "popup_html": "\n<div class=\"ui container\">\n    <div class=\"pop_up\">\n        <img src=\"\"><br/>\n        <h2>Thank you for Contacting Us</h2>\n        <span>\n            <div id=\"reference\"></div><br/>\n            For any Services 24 hours before flight departure & for prompt response<br/>CALL <b>+91-011-42521000</b>\n        </span>\n    </div>\n</div>\n"
//       }
//   ],
//   "statusCode": 200,
//   "data": {
//       "message": "success"
//   }
// }